// Opens a new browser tab/window and prints shipping labels for a list of QR codes.
// Uses Blob + object URL instead of `document.write` for safer rendering and
// to satisfy XSS-via-document.write linters. All untrusted strings flow through
// `escapeHtml` to neutralize any HTML/JS injection.

export function escapeHtml(s) {
  return String(s ?? "").replace(/[&<>"']/g, (c) => ({
    "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;",
  }[c]));
}

export function openPrintWindow(html, opts = "width=520,height=720") {
  if (typeof window === "undefined") return null;
  const blob = new Blob([html], { type: "text/html;charset=utf-8" });
  const url = URL.createObjectURL(blob);
  const w = window.open(url, "_blank", opts);
  // Revoke the URL once the new tab has consumed it. Slight delay so the
  // browser has time to fetch & render before we release the blob.
  setTimeout(() => URL.revokeObjectURL(url), 30_000);
  return w;
}

export function printQRLabels(labels) {
  // labels: [{qr_image, qr_code_id, store_name, assigned_product_name }]
  if (!labels || labels.length === 0) return;
  const labelHtml = labels.map(l => `
    <div class="label">
      <div class="brand">DeliveryBoss</div>
      <img src="${escapeHtml(l.qr_image)}" alt="QR" />
      <div class="row"><span>QR ID</span><b>${escapeHtml(l.qr_code_id)}</b></div>
      <div class="row"><span>Store</span><b>${escapeHtml(l.store_name)}</b></div>
      ${l.assigned_product_name ? `<div class="row"><span>Product</span><b>${escapeHtml(l.assigned_product_name)}</b></div>` : ""}
      <div class="instr">Scan for package details</div>
    </div>
  `).join("");
  const html = `<!doctype html><html><head><meta charset="utf-8"><title>Print Labels</title>
    <style>
      @page { size: 4in 6in; margin: 0.2in; }
      * { box-sizing: border-box; }
      body { font-family: ui-monospace, Menlo, Monaco, monospace; margin: 0; padding: 0; }
      .label { padding: 16px; page-break-after: always; text-align: center; }
      .label:last-child { page-break-after: auto; }
      .label .brand { font-family: system-ui; font-weight: 800; font-size: 22px; margin-bottom: 8px; letter-spacing: -0.02em; }
      .label img { width: 260px; height: 260px; image-rendering: pixelated; display: block; margin: 0 auto 10px; }
      .label .row { display: flex; justify-content: space-between; margin: 4px 0; font-size: 11px; padding: 0 6px; }
      .label .row span { color: #555; text-transform: uppercase; letter-spacing: 0.1em; }
      .label .row b { font-family: ui-monospace, monospace; }
      .label .instr { margin-top: 8px; font-size: 10px; color: #777; border-top: 1px dashed #999; padding-top: 6px; text-transform: uppercase; letter-spacing: 0.2em; }
      @media screen {
        body { background: #e7e7e7; padding: 24px; }
        .label { background: #fff; border: 1px solid #ccc; margin-bottom: 12px; max-width: 4in; margin-left: auto; margin-right: auto; }
      }
    </style></head><body>
    ${labelHtml}
    <script>window.onload=()=>setTimeout(()=>window.print(),300);</script>
    </body></html>`;
  openPrintWindow(html);
}
